import { defineNuxtPlugin } from '#app/nuxt'
import { LazyButtonLoading, LazyInputNumber, LazyMagicJump, LazyNuxtImgWrapConst, LazyNuxtImgWrap, LazyReCaptchaDialog, LazySelectInput, LazyScroll, LazySelectUnderline, LazyFooterSection, LazyHeaderSection, LazyNavSection, LazyComponentsCurrencyPicker, LazyComponentsMagicJump, LazyComponentsResponsiveNavDrawer, LazyComponentsSearch, LazyComponentsCartDrawer, LazyComponentsComponentsSearchPart, LazyDataHeaderData } from '#components'
const lazyGlobalComponents = [
  ["ButtonLoading", LazyButtonLoading],
["InputNumber", LazyInputNumber],
["MagicJump", LazyMagicJump],
["NuxtImgWrapConst", LazyNuxtImgWrapConst],
["NuxtImgWrap", LazyNuxtImgWrap],
["ReCaptchaDialog", LazyReCaptchaDialog],
["SelectInput", LazySelectInput],
["Scroll", LazyScroll],
["SelectUnderline", LazySelectUnderline],
["FooterSection", LazyFooterSection],
["HeaderSection", LazyHeaderSection],
["NavSection", LazyNavSection],
["ComponentsCurrencyPicker", LazyComponentsCurrencyPicker],
["ComponentsMagicJump", LazyComponentsMagicJump],
["ComponentsResponsiveNavDrawer", LazyComponentsResponsiveNavDrawer],
["ComponentsSearch", LazyComponentsSearch],
["ComponentsCartDrawer", LazyComponentsCartDrawer],
["ComponentsComponentsSearchPart", LazyComponentsComponentsSearchPart],
["DataHeaderData", LazyDataHeaderData],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
